// extracted by mini-css-extract-plugin
export var completionBody = "_l4-2";
export var completionCard = "_l4-0";
export var completionFooter = "_l4-3";
export var completionTitle = "_l4-1";